import {useTranslation} from '#imports';

/**
 * Return date patterns for the datepicker and input mask components
 */
export function useDatePatterns() {
    const {t} = useTranslation();

    return {
        // Normal date patterns dd/MM/yyyy
        dateUnicodePattern: t('generic.form.date.unicode.pattern'),
        dateMaskPattern: t('generic.form.date.mask.pattern'),
        datePlaceholderPattern: t('generic.form.date.placeholder.pattern'),
        // Month year date patterns MM/yyyy
        dateMonthYearMaskPattern: t('generic.form.date.month.year.mask.pattern'),
        dateMonthYearUnicodePattern: t('generic.form.date.month.year.unicode.pattern'),
        dateMonthYearPlaceholderPattern: t('generic.form.date.month.year.placeholder.pattern'),
        // Datetime patterns dd/MM/yyyy HH:mm
        dateTimeUnicodePattern: t('generic.form.datetime.unicode.pattern'),
        dateTimeMaskPattern: t('generic.form.datetime.mask.pattern'),
        dateTimePlaceholderPattern: t('generic.form.datetime.placeholder.pattern'),
        // Year only placeholder pattern
        yearOnlyPlaceholderPattern: t('generic.form.year.only.placeholder.pattern'),
    };
}
